import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=3f99928a&lang=pug&"
import script from "./Catalog.vue?vue&type=script&lang=js&"
export * from "./Catalog.vue?vue&type=script&lang=js&"
import style0 from "vuelendar/scss/vuelendar.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./Catalog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports